import React, { useContext } from 'react';
import { EditorContext } from '../EditorCommon/EditorContext';
import { MaterialSelector } from '../EditorCommon/MaterialSelector';

export function InteriorMaterialSelector(props:{
	
}) {

    const ec = useContext(EditorContext);


    const productLine = ec.cabinetService.getProductLine();
    const productGroups = productLine?.interiorProducts
        ?? ec.cabinetService.chainInfo.productLines.flatMap(pl => pl.interiorProducts);
    const activeMaterialIds = productGroups.flatMap(pg => pg.interiorProductSubGroups)
        .flatMap(psg => psg.products)
        .flatMap(p => p.materials)
        .map(m => m.interiorMaterialId);
    const activeMaterialIdSet = new Set(activeMaterialIds);

    const interiorMaterials = ec.cabinetService.chainInfo.interiorMaterials
        .filter(im => activeMaterialIdSet.has(im.id));
    if (interiorMaterials.length < 2)
        return null;

    let materials = interiorMaterials.map(im => ({
        id: im.id,
        name: im.name,
        sampleImageUrl: im.sampleImageUrl,
        textureImageUrl: null
    }));



    return (
        <MaterialSelector
            header={ec.translator("interior material selector header", "Materiale")}
            materials={materials}
            currentId={ec.cabinet.interiorMaterialId ?? undefined}
            onSelect={newMat => ec.cabinetService.interior.setInteriorMaterialId(newMat.id)}
        />
	);
}
